import HospitalUsers from './HospitalUsers';

export default HospitalUsers;
